import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import { isMgbwWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import { css } from "styled-components";

// MGBW sizes all form fields to 48px globally (ELEMENTS.formField.inputHeight in Start.tsx).
// On the Projects (My Lists) page the search box must match Surya, so pin this field back to 40px.
searchBoxStyles.search = {
    ...searchBoxStyles.search,
    cssOverrides: {
        ...searchBoxStyles.search?.cssOverrides,
        formInputWrapper: css`
            ${() =>
                isMgbwWebsite()
                    ? css`
                          input {
                              height: 40px !important;
                              padding: 12px 13px;
                          }
                      `
                    : null}
        `,
    },
};
